import { useForm as createUseForm } from "@ant-design-vue/use";
import { toRaw } from "vue";
// import { createFieldRadioGroup } from "../../../../../../components/input/template-builder/template-builder.logic";
import { conditionFormChecker, initUseForm } from "../../../../../../utils/form";
import { createLoading } from "../../../../../../utils/loading";
import { required, validateError } from "../../../../../../utils/validate";
import moment from "moment/moment";
import store from "../../../../../../store";
import { createFieldSelect } from "../../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../../i18n";
import lodash from "lodash";

export const { isLoading, setIsLoading } = createLoading();

export const callInspection = ({ searchQuery, userInfo }) => {
    console.log("userInfo", userInfo)
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
        { name: "refRelease.id", type: "UUID", operator: "=", value: null },
    ];
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/inspection/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const onClickModalOk = ({ data }) => {
    console.log("onClickModalOk data", data)
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        refInspection: null
    };
};

export const createRules = () => {
    return {
        refInspection: [required]
    };
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    console.log("props", props)
    console.log("modelRef", modelRef)
    return [
        createFieldSelect({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            key: `${prefix}refInspection`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t("model.release.refInspection.approveCode"),
            inputProp: ({ field }) => {
                return lodash.merge(
                    {
                        value: model.refInspection,
                        "onUpdate:value": value => {
                            model.refInspection = value;
                        },
                        disabled: viewOnly,
                        list: ({ searchQuery }) => callInspection({ searchQuery, userInfo: store.state.resource.auth.info?.user }),
                        renderLabel: ({ item }) => (
                            <div>
                                {item.approveCode} - {item.refUserCompany?.fullNameTh}
                            </div>
                        ),
                        allowClear: false
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                );
            },
        }),
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
